import React from 'react';
import { Box, Typography } from '@material-ui/core';

const Blog = () => {
    return (
        <Box component={"div"} display="flex" justifyContent="center" alignItems="center">
              <Typography variant="h1" color="secondary">
                  Blog Page <br/> Comming Soon......
              </Typography>                                                                                           
        </Box>

    );
};

export default Blog;